import { render, staticRenderFns } from "./OpinionItem.vue?vue&type=template&id=3b547a52&scoped=true&"
import script from "./OpinionItem.vue?vue&type=script&lang=js&"
export * from "./OpinionItem.vue?vue&type=script&lang=js&"
import style0 from "./OpinionItem.vue?vue&type=style&index=0&id=3b547a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b547a52",
  null
  
)

export default component.exports